import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import CreateScreens from '../../../components/TaskLayout/Screens/CreateScreens'
import ScreenSchemes from '../../../components/TaskLayout/Screens/ScreenSchemes'
import { useLocation } from 'react-router-dom'

const Screens = () => {

    const location = useLocation()?.state
    const [filterValues, setFilterValues] = useState({});
    const fieldTabs = [
        {
            key: "screens",
            label: "Screens"
        },
        {
            key: "screens_schemes",
            label: "Screens Schemes"
        }
    ]

    useEffect(() => {
        if (location?.layout) {
            setFilterValues((prev) => ({ ...prev, tab: "screens_schemes", layout: location?.layout, apiCall: true }));
        } else {
            setFilterValues((prev) => ({ ...prev, tab: "screens", apiCall: true }));
        }
    }, [location])

    return (
        <div>
            <div className='m-2 d-flex justify-content-between'>
                <div className='tab-menu'>
                    {fieldTabs?.map(item => (
                        <div className={`tab-menu-item ${item?.key === filterValues?.tab && "active"}`} onClick={() => { if (item?.key !== filterValues?.tab) { setFilterValues((prev) => ({ ...prev, tab: item?.key, apiCall: true, layout: {}, config: {} })); } }}>{item?.label}</div>
                    ))}
                </div>
                <div>
                    <button className='sk-btn sk-btn-primary' onClick={() => setFilterValues(prev => ({ ...prev, apiCall: true }))}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                </div>
            </div>
            <div className='px-2'>
                {filterValues?.tab === "screens" && <CreateScreens filterValues={filterValues} setFilterValues={setFilterValues} />}
                {filterValues?.tab === "screens_schemes" && <ScreenSchemes filterValues={filterValues} setFilterValues={setFilterValues} />}
            </div>
        </div>
    )
}

export default Screens